/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEmailDto
 */
export interface UserEmailDto {
    /**
     * User Id
     * @type {string}
     * @memberof UserEmailDto
     */
    userId?: string;
    /**
     * User's email.
     * @type {string}
     * @memberof UserEmailDto
     */
    value?: string;
}

/**
 * Check if a given object implements the UserEmailDto interface.
 */
export function instanceOfUserEmailDto(value: object): boolean {
    return true;
}

export function UserEmailDtoFromJSON(json: any): UserEmailDto {
    return UserEmailDtoFromJSONTyped(json, false);
}

export function UserEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function UserEmailDtoToJSON(value?: UserEmailDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'value': value['value'],
    };
}

